
<button class="fdm-button" mat-flat-button color="primary" style="color:#fff;height:25px;" (click)="addStep()"> 
    <fa-icon icon="plus-circle"></fa-icon> &nbsp;Add step
</button>

<hr/>

<div class="sections fdm-buttons" cdkDropList [cdkDropListData]="steps" (cdkDropListDropped)="dropStep($event)">

    <div *ngFor="let step of steps;let idx = index" cdkDragLockAxis="y" cdkDrag class="section clearfix">
        
        <div class="section-header fdm-dragging clearfix" cdkDragHandle>
            <fa-icon icon="times-circle" class="fdm-linked float-right" (click)="removeStep(step)"></fa-icon>
            <span> 
                <span class="fdm-chevron">
                    <fa-icon *ngIf="step.display" icon="chevron-down" class="fdm-linked" (click)="hide(step)"></fa-icon> 
                    <fa-icon *ngIf="!step.display" icon="chevron-right" class="fdm-linked" (click)="show(step)"></fa-icon> 
                </span>
                Step <span class="fdm-count-big">{{ idx + 1}}</span>
            </span>

            <span style="color:#aaa;line-height:13px;font-size:12px;margin-left:35px;">hide step header <mat-checkbox style="margin:0;padding:0;" [(ngModel)]="step.hideHeader" (change)="resetParentCache()"></mat-checkbox></span>
            <div class="clearfix"></div>
        </div>

        <div class="section-content" [hidden]="!step.display">
            <div cdkDropList [cdkDropListData]="step.states" (cdkDropListDropped)="dropState($event)">

                <div class="section-toolbar">
                    <b>Setup for state</b> 
                    <span *ngFor="let st of states"> 
                        <mat-checkbox [checked]="hasState(step,st)" (change)="setupState(step,st,$event)"></mat-checkbox>  
                        {{ st.label }}
                    </span>
                </div>
                
                <div *ngFor="let state of step.states; let idx_state = index;" cdkDrag>

                    <div class="section-header fdm-dragging clearfix" cdkDragHandle>
                        <span class="fdm-chevron">
                            <fa-icon *ngIf="state.display" icon="chevron-down" class="fdm-linked" (click)="hide(state)"></fa-icon> 
                            <fa-icon *ngIf="!state.display" icon="chevron-right" class="fdm-linked" (click)="show(state)"></fa-icon> 
                        </span>
                        State <span class="fdm-count-big">{{ state.label }}</span>
                    </div>
                    

                    <div [hidden]="!state.display" class="" cdkDropListGroup>
                        
                        <div class="section-toolbar" cdkDropList [cdkDropListData]="itemTypes">
                            <span *ngFor="let option of itemTypes" class="fdm-dragging" cdkDragLockAxis="y" cdkDrag> <fa-icon [icon]="option.icon"></fa-icon> {{ option.label }}</span>
                        </div>

                        <div class="section-items" cdkDropList [cdkDropListData]="state.items" (cdkDropListDropped)="dropItem($event)">

                            <div *ngFor="let item of state.items" class="section-item" cdkDragLockAxis="y" cdkDrag>

                                <fa-icon icon="times-circle" class="fdm-linked float-right" style="margin-left:8px;" (click)="removeItem(item,state)"></fa-icon>
                                <fa-icon icon="code-branch" class="fdm-linked float-right" style="margin-left:8px;" (click)="addCondition(item)"></fa-icon>
                                
                                <span class="fdm-dragging float-left" cdkDragHandle> <fa-icon [icon]="item.icon"></fa-icon> {{ item.label }}</span>

                                <div class="options">

                                    <ng-container *ngIf="item.id == 'text'">

                                        <select class="section-item-option" [(ngModel)]="item.type" (change)="resetParentCache()">
                                            <option *ngFor="let option of textTypes" [value]="option.id">{{ option.label }}</option>
                                        </select>
                                        <span class="section-item-option">
                                            Token <input [(ngModel)]="item.text_token" [value]="item.text_token" (change)="resetParentCache()" />
                                        </span>
                                        <span class="section-item-option">
                                            Text <span class="input-to-textarea"><textarea [(ngModel)]="item.value" (change)="resetParentCache()">{{ item.value }}</textarea></span>
                                        </span>
                                        
                                    </ng-container>

                                    <ng-container *ngIf="item.id == 'input'">

                                        <select class="section-item-option" [(ngModel)]="item.type" (change)="resetParentCache()">
                                            <option *ngFor="let option of inputTypes" [value]="option.id">{{ option.label }}</option>
                                        </select>

                                        <span class="section-item-option">
                                            Label <input class="section-item-option" [(ngModel)]="item.label_token" [value]="item.label_token" placeholder="Leave blank if no label" (change)="resetParentCache()" />
                                        </span>

                                        <ng-container *ngIf="item.type == 'number' || item.type == 'slider'">
                                            <span class="section-item-option">
                                                Default <input class="small" [(ngModel)]="item.value" [value]="item.value" />
                                            </span>
                                            <span class="section-item-option">
                                                Min <input class="small" [(ngModel)]="item.min" [value]="item.min" />
                                            </span>
                                            <span class="section-item-option">
                                                Max <input class="small" [(ngModel)]="item.max" [value]="item.max" />
                                            </span>
                                            <span class="section-item-option">
                                                Step <input class="small" [(ngModel)]="item.step" [value]="item.step" />
                                            </span>
                                        </ng-container>
                                        
                                    </ng-container>

                                    <ng-container *ngIf="item.id == 'control'">

                                        <select class="section-item-option" [(ngModel)]="item.type" (change)="resetParentCache()">
                                            <option *ngFor="let option of controlTypes" [value]="option.id">{{ option.label }}</option>
                                        </select>

                                        <span class="section-item-option">
                                            Label <input class="section-item-option" [(ngModel)]="item.label_token" [value]="item.label_token" placeholder="Leave blank if no label" (change)="resetParentCache()" />
                                        </span>

                                        <ng-container *ngIf="item.type == 'button'">
                                            <span class="section-item-option">
                                                Button text <input class="section-item-option" [(ngModel)]="item.text_token" [value]="item.text_token" (change)="resetParentCache()" />
                                            </span>
                                            <span class="section-item-option">
                                                Action <select [(ngModel)]="item.action" (change)="resetParentCache()">
                                                    <option *ngFor="let option of actionTypes" [value]="option.id">{{ option.label }}</option>
                                                </select>
                                            </span>
                                            <span class="section-item-option" *ngIf="item.action == 'goto'">
                                                Step <select [(ngModel)]="item.action_param">
                                                    <option *ngFor="let s of steps" [value]="s.id">{{ getStepLabel(s.id) }}</option>
                                                </select>
                                            </span>
                                            <span class="section-item-option" *ngIf="item.action == 'show' || item.action == 'hide'">
                                                Item <select [(ngModel)]="item.action_param">
                                                    <option *ngFor="let s of state.items" [value]="s.uid">{{ getItemLabel(s.uid) }}</option>
                                                </select>
                                            </span>
                                        </ng-container>
                                        
                                        <ng-container *ngIf="item.type == 'check'">
                                            <span class="section-item-option">
                                                Default <mat-checkbox [value]="item.value" [(ngModel)]="item.value" (change)="resetParentCache()"></mat-checkbox> 
                                            </span>
                                        </ng-container>
                                        
                                    </ng-container>

                                    <ng-container *ngIf="item.id == 'action'">
                                        <select class="section-item-option" [(ngModel)]="item.type" (change)="resetParentCache()">
                                            <option *ngFor="let option of actionTypes" [value]="option.id">{{ option.label }}</option>
                                        </select>
                                        <select class="section-item-option" *ngIf="item.type == 'goto'" [(ngModel)]="item.value">
                                            <option *ngFor="let s of steps" [value]="s.id">{{ getStepLabel(s.id) }}</option>
                                        </select>
                                    </ng-container>
                                </div>
                                <div class="conditions" *ngIf="item.conditions" cdkDropList [cdkDropListData]="item.conditions" (cdkDropListDropped)="dropCondition($event)">
                                    <div *ngFor="let condition of item.conditions" class="section-item condition" cdkDragLockAxis="y" cdkDrag>
                                        
                                        <fa-icon icon="times-circle" class="fdm-linked float-right" (click)="removeCondition(item,condition)"></fa-icon>
                                        <span class="fdm-dragging" cdkDragHandle><fa-icon icon="code"></fa-icon> Condition</span>

                                        <span class="section-item-option">
                                            <input [(ngModel)]="condition.thisOne" (change)="resetParentCache()" />
                                            <select [(ngModel)]="condition.check" (change)="resetParentCache()">
                                                <option *ngFor="let option of checkTypes" [value]="option.id">{{ option.label }}</option>
                                            </select> 
                                            <input [(ngModel)]="condition.thatOne" (change)="resetParentCache()" />
                                        </span>
                                        
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="state.items.length < 1">Drag your items here from the toolbar above to get started.</div>
                        </div>
                    </div>


                </div>
            </div>
        </div>

        

    </div>

    <!-- <textarea style="width:100%;height:200px;font-size:9px;margin-top:30px;">{{ steps | json }}</textarea> -->

</div>